import { createBrowserClient } from '@supabase/ssr';

import { extractDomain } from '../url';

const lelandUrl = process.env.NEXT_PUBLIC_LELAND_APPLICANT_URL;
const domain = lelandUrl ? extractDomain(lelandUrl) : undefined;

export const supabase = createBrowserClient(
  process.env.NEXT_PUBLIC_SUPABASE_URL ?? '',
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ?? '',
  {
    cookieOptions: {
      domain: `.${domain}`,
      path: '/',
      secure: process.env.NODE_ENV === 'production',
      sameSite: 'lax',
    },
  },
);
